var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-avatar',{class:_vm.styleClass,attrs:{"variant":_vm.variant,"size":_vm.size,"text":_vm.generateTwoLetterFromName(_vm.text),"src":_vm.src,"icon":_vm.src,"rounded":_vm.rounded,"square":_vm.square}})
}
var staticRenderFns = []

export { render, staticRenderFns }